import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab729fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "vendor-status-card",
  class: "tw-bg-[#FCFCFC] tw-h-[119px] tw-w-[100%] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}
const _hoisted_2 = { class: "tw-flex tw-h-full tw-justify-between" }
const _hoisted_3 = { class: "tw-flex tw-flex-1 tw-p-5" }
const _hoisted_4 = { class: "detail-info" }
const _hoisted_5 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-not-italic" }
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-items-center tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-not-italic" }
const _hoisted_7 = {
  key: 0,
  class: "tw-text-[#387DFF] tw-text-[13px]"
}
const _hoisted_8 = {
  key: 0,
  class: "tw-flex tw-justify-between tw-items-center tw-font-[500] tw-my-[11px]"
}
const _hoisted_9 = { class: "tw-font-[400]" }
const _hoisted_10 = { class: "tw-pr-1 tw-text-[#B7B7B7]" }
const _hoisted_11 = { class: "tw-text-[#878787]" }
const _hoisted_12 = {
  key: 1,
  class: "tw-flex tw-justify-between tw-items-center tw-font-[500] tw-my-[11px]"
}
const _hoisted_13 = { class: "tw-text-[#878787] tw-font-[400]" }
const _hoisted_14 = {
  key: 2,
  class: "tw-flex tw-justify-between tw-items-center tw-font-[500]"
}
const _hoisted_15 = { class: "tw-font-[400]" }
const _hoisted_16 = { class: "tw-pr-1 tw-text-[#B7B7B7]" }
const _hoisted_17 = { class: "tw-text-[#878787]" }
const _hoisted_18 = {
  key: 3,
  class: "tw-flex tw-justify-between tw-items-center tw-font-[500]"
}
const _hoisted_19 = { class: "tw-text-[#878787] tw-font-[400]" }
const _hoisted_20 = {
  key: 0,
  class: "tw-px-[5px] sm:tw-p-[20px] tw-border-l tw-border-solid tw-border-[#EFF0F1] tw-h-full tw-border-[0] tw-flex tw-justify-center tw-items-center tw-min-w-[80px]"
}

import { getComponentUiText } from "@/utils/utilities";
import {
  convertUTCTimeToLocalTime,
  getTimeFromNow,
} from "@/utils/dateTimeUtils";
import StatusBadge from "../common/setting/statusBadge.vue";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import VendorStatusBadge from "./vendorStatusBadge.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorStatusCard',
  props: {
  isShowTag: {
    type: Boolean,
    required: false,
    default: true,
  },
  subText1: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-component-assessments-status-card-created-1",
    ),
  },
  subValue1: {
    type: String,
    required: false,
    default: "",
  },
  subText2: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-component-assessments-status-card-last-updated-1",
    ),
  },
  isShowScore: {
    type: Boolean,
    required: false,
    default: true,
  },
  status: {
    type: Object,
    required: true,
    default: () => ({
      statusCode: "active",
      statusId: "active",
      radialValue: 0,
      progress: {
        type: Object,
        required: false,
        default: () => ({
          completed: 0,
          total: 0,
          percent: 0,
        }),
      },
      score: {
        type: Object,
        required: false,
        default: () => ({
          completed: 0,
          total: 0,
          percent: 0,
        }),
      },
    }),
  },
},
  setup(__props) {

const props = __props;


const getCurrentTime = () => {
  if (!props.status.created) return "-";
  return convertUTCTimeToLocalTime(
    props.status.created,
    undefined,
    "HH:mm",
    "MMMM",
    " - ",
  );
};
const getStartedTime = (time: any) => {
  return getTimeFromNow(time);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-status-1")) + " ", 1),
              (__props.isShowTag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(VendorStatusBadge, {
                      class: "tw-h-[100%] tw-flex tw-leading-[100%] tw-pb-[2px] tw-truncate tw-w-fit",
                      value: __props.status.statusId
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (props.status.progress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(__props.subText1) + " ", 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(props.status.progress.completed) + "/" + _toDisplayString(props.status.progress.total), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(props.status.progress.percent) + "%", 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(__props.subText1) + " ", 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(getCurrentTime()), 1)
                ])),
            (props.status.score)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(__props.subText2) + " ", 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(props.status.score.completed) + "/" + _toDisplayString(props.status.score.total), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(props.status.score.percent) + "%", 1)
                  ])
                ]))
              : (__props.isShowScore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createTextVNode(_toDisplayString(__props.subText2) + " ", 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(props.status.started
                    ? getStartedTime(props.status.started)
                    : "-"), 1)
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      (props.status.progress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(RadialProgressBar, {
              class: "d-inline",
              "total-steps": 100,
              "completed-steps": __props.status.radialValue,
              "is-hide-progress": true,
              "outer-stroke-color": "#48A0FF"
            }, null, 8, ["completed-steps"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})